/**
 * Section Component Renderer
 *
 * Renders section components with nested component loader support.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
import { spreadProps } from '../utils/spread-props';
/**
 * Allowed props for uap-app-integration-settings-section component
 */
const sectionAllowedProps = new Set([
    'visible',
    'section-type',
    'class',
    'state',
    'show-when',
]);
/**
 * Render a section component
 *
 * @param {SectionData} data - The section data to render
 * @param {SectionData} data - The section data to render
 *
 * @return {TemplateResult} The rendered section component
 */
export function sectionRenderer(data) {
    const { components = [], ...rest } = data;
    const spreadSectionProps = spreadProps(sectionAllowedProps);
    return html `
		<uap-app-integration-settings-section
			${spreadSectionProps(rest)}
		>
			<uap-app-integration-settings-component-loader 
				.config=${{ components }}
			>
			</uap-app-integration-settings-component-loader>
		</uap-app-integration-settings-section>
	`;
}
